var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-row', _vm.className]},[_c('div',{class:{
            'form-row-inner-container': !_vm.noLabel,
            'form-row-inner-container-value-only': _vm.noLabel,
            'form-row-vertical': _vm.vertical,
        }},[(!_vm.noLabel)?_c('div',{staticClass:"label-container"},[_c('FormLabel',[_vm._t("label")],2)],1):_vm._e(),_c('div',{staticClass:"inputs-container"},[_vm._t("inputs")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }